import { useQuery } from "@tanstack/react-query";
import { getAirshipStatus } from "../../api/bAirshipApi";

export const useGetAirshipStatus = (organisationId, locationId=null, brandId=null, enabled = true) => {
  return useQuery({
    queryKey: ["airship-status", organisationId, locationId, brandId],
    queryFn: () => getAirshipStatus(organisationId, locationId, brandId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};
